import React, { createContext, useContext, useMemo, useState } from 'react';

const ReportsHeaderContext = createContext({
  api: null,
  setReportsSearchApi: () => {},
  searchQuery: '',
  setSearchQuery: () => {},
});

export function ReportsHeaderProvider({ children }) {
  const [api, setReportsSearchApi] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const value = useMemo(
    () => ({ api, setReportsSearchApi, searchQuery, setSearchQuery }),
    [api, searchQuery]
  );

  return (
    <ReportsHeaderContext.Provider value={value}>
      {children}
    </ReportsHeaderContext.Provider>
  );
}

export function useReportsHeader() {
  return useContext(ReportsHeaderContext);
}
